export default __webpack_public_path__ + "static/media/highKneeSeven.2bd7ffc6.png";